module.exports = __webpack_public_path__ + "img/step6.cb72eb47.png";